<app-page-stepper
    [verticalSteps]="false"
    [submitVisible]="false"
    [isLoading]="isLoading"
    (stepChange)="onStepChange($event)"
    (tryNext)="onTryNext()">
    <app-stepper [canContinue]="selectedLine && selectedToolRequest">
        <ng-template #title>{{ 'lineSetter.tool-returns.stepper.select-line-and-tool-request.title' | translate }}
        </ng-template>
        <ng-template #content
                     let-step="step">
            <app-search-line-and-request
                [isLoading]="isLoading"
                (lineChanged)="onLineChanged($event)"
                (toolChanged)="onToolRequestChanged($event)"
            ></app-search-line-and-request>
        </ng-template>
    </app-stepper>
    <app-stepper>
        <ng-template #title>{{ 'lineSetter.tool-returns.stepper.confirm.title' | translate }}</ng-template>
        <ng-template #content>
            <div class="content">
                <div class="header">
                    <h2>{{ 'lineSetter.tool-returns.stepper.confirm.title' | translate }}</h2>
                </div>
                <div class="body">
                    <div *ngIf="currentStep == 2 && !toolsLoading; else loadingAnimation">
                        <div class="row" *ngIf="toolsNeededAtLine.length > 0">
                            <app-tool-scan-tree
                                labelText="{{'lineSetter.maintenance-tool-returns.toolsAtLine'| translate}}"
                                [items]="toolsNeededAtLine">
                            </app-tool-scan-tree>
                        </div>
                        <div class="row" *ngIf="toolsNeededToBeReturned.length > 0">
                            <app-tool-scan-tree
                                [isMaterial]="false"
                                labelText="{{'lineSetter.maintenance-tool-returns.toolsToBeReturned'| translate}}"
                                [items]="toolsNeededToBeReturned">
                            </app-tool-scan-tree>
                        </div>
                        <div class="row" *ngIf="toolsExcludedFromMaintenance.length > 0">
                            <app-tool-scan-tree
                                [isMaterial]="false"
                                labelText="{{'lineSetter.maintenance-tool-returns.toolsExcludedFromMaintenance'| translate}}"
                                [items]="toolsExcludedFromMaintenance">
                            </app-tool-scan-tree>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <app-icon-button
                        [disabled]="toolsNeededToBeReturned.length == 0 && toolsNeededAtLine.length == 0"
                        text="{{ 'generic.buttons.confirm' | translate }}"
                        variant="fa-check"
                        class="confirm-button"
                        [responsive]="true"
                        [inline]="true"
                        (click)="onConfirmClick()">
                    </app-icon-button>
                </div>
            </div>
        </ng-template>
    </app-stepper>
</app-page-stepper>
<app-confirmation-modal (confirmEvent)="onConfirmReturn($event)"
                        #successModal
                        title="{{'lineSetter.maintenance-tool-returns.pages.popupTitle' | translate}}"
                        [displayReasonLabel]="'lineSetter.maintenance-tool-returns.forms.maintenanceReason' | translate"
                        [displayReasonPlaceholder]="'lineSetter.maintenance-tool-returns.forms.reasonMessage' | translate"
                        [isConfirmationInProgress]="isConfirmationInProgress"
                        [reasonMandatory]="true"
                        [confirmWithReason]="true">
</app-confirmation-modal>
<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage"
                        [confirmOnlyMode]="true"
                        [showConfirmButton]="false ">
</app-confirmation-modal>
<app-logout-modal
    title="{{ 'lineSetter.maintenance-tool-returns.pages.logoutModal.title' | translate }}"
    infoMessage="{{ 'lineSetter.maintenance-tool-returns.pages.logoutModal.infoMessage' | translate }}"
    [timer]="badgeLogoutCountdownSeconds">
</app-logout-modal>
<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
